import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { successfullyAppliedPageCarousel } from '../../constants/MarketplaceConstants';
import { Carousel } from 'react-responsive-carousel';
import thumbsUp from '../../assets/thumbs_up.png';
import specialist from '../../assets/specialist.png';
import { useHistory } from 'react-router-dom';
import BottomButton from '../Buttons/BottomButton';
import delivery_scooter from '../../assets/delivery_scooter.svg';
import company_group from '../../assets/company_group.svg';
import guy_with_cash from '../../assets/guy_with_cash.svg';
import {Navigation} from "../../services/NavigationService";
import { Routes } from "../../constants/RouterConstants";

const FindingJobsContainer = styled.div`
height: 100%;

  .finding-jobs-parent{
    display: flex;
    flex-direction: column;
    justify-content: end;
  }

  .top-section-txt {
    font-weight: 700;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    color: #d34b18;
  }

  .top-section-img {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .top-section-status-txt {
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    color: #555555;
  }

  .middle-section {
    margin-top: 28px;
    display: flex;
    justify-content: center;
  }

  .lower-section {
    margin-top: 12px;
    display: flex;
    justify-content: center;
  }
`;

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const FindingJobs = () => {
  const query = useQuery();
  const history = useHistory();
  const city = query.get('city') ? query.get('city') : '';

  useEffect(() => {
    setTimeout(() => {
      const route = {
        pathname: Routes.JOB_LISTINGS,
        search: `city=${city}`,
      };
      Navigation.push(route);
    }, 5000);
  }, []);

  return (
    <FindingJobsContainer>
      <div className="finding-jobs-parent">
        <div className="top-section">
          <div className="top-section-txt">Thank you for your details!</div>

          <div className="top-section-img">
            <img className="scooter-img" src={delivery_scooter} alt="" />
          </div>

          <div className="top-section-status-txt">Finding the Best Jobs for You!</div>
        </div>

        <div className="middle-section">
          <img className="company-group-img" src={company_group} alt="" />
        </div>

        <div className="lower-section">
          <img className="guy-with-cash-img" src={guy_with_cash} alt="" />
        </div>
      </div>
    </FindingJobsContainer>
  );
};

export default FindingJobs;
